// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mdc-tooltip__surface {
  background-color: #4d6f86 !important;
  font-size: 0.7rem !important;
}

.question_icon {
  position: absolute;
  right: 4rem;
  top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/documentation/user-manuals-download/user-manuals-download.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,4BAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AACF","sourcesContent":["::ng-deep .mdc-tooltip__surface {\r\n  background-color: rgba(#4d6f86, 1) !important;\r\n  font-size: 0.7rem !important;\r\n}\r\n\r\n.question_icon {\r\n  position: absolute;\r\n  right: 4rem;\r\n  top: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
